// Components==============
import { motion } from "framer-motion";
import React from "react";
// import { interactiveScale } from 'utilities/framer';
import styles from "./Button.module.scss";
// =========================

type Variant =
  | "primary"
  | "white"
  | "secondary"
  | "modalStopActive"
  | "modalStopInActive"
  | "modalCancelActive"
  | "modalCancelInActive";

type Props = {
  children: React.ReactNode;
  variant?: Variant;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  to?: string;
  inactive?: boolean;
  color?: string;
};

export default function Button({
  children,
  variant = "primary",
  onClick,
  to,
  inactive,
  color,
}: Props) {
  return (
    <motion.button
      onClick={
        to
          ? (e) => {
              e.stopPropagation();
            }
          : onClick
      }
      type={to ? "button" : "submit"}
      className={`${styles.button} ${styles[variant]} ${color ? styles[color] : ""}`}
      style={
        inactive
          ? {
              pointerEvents: "none",
              opacity: 0.5,
            }
          : {}
      }
      // {...interactiveScale}
    >
      {children}
    </motion.button>
  );
}
